// Categoriepagina: sorteren zonder de pagina te herladen (Section Rendering API) en hulptegels met een anker dat niet op de pagina staat verbergen.

class CollectionSort extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    // Pijltjestoetsen op een dichte select geven per stap een change: even wachten voorkomt een verzoek per stap.
    this.form.addEventListener('change', () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.update(), 350);
    });
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.update();
    });
  }

  async update() {
    const url = new URL(this.form.getAttribute('action'), window.location.origin);
    url.search = new URLSearchParams(new FormData(this.form)).toString();
    const root = this.closest('[data-collection-products]');
    if (!root) {
      window.location.assign(url);
      return;
    }

    this.controller?.abort();
    this.controller = new AbortController();
    root.setAttribute('aria-busy', 'true');
    try {
      const sectionUrl = new URL(url);
      sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(sectionUrl, { signal: this.controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');

      root.querySelectorAll('[data-collection-swap]').forEach((element) => {
        const fresh = html.getElementById(element.id);
        if (fresh) element.replaceWith(fresh);
      });
      const count = root.querySelector('[data-collection-count]');
      const freshCount = html.querySelector('[data-collection-count]');
      if (count && freshCount) count.textContent = freshCount.textContent;

      window.history.replaceState(window.history.state, '', url);
      root.removeAttribute('aria-busy');
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(url);
    }
  }
}

if (!customElements.get('collection-sort')) customElements.define('collection-sort', CollectionSort);

// Een hulptegel naar #anker zonder doel op deze pagina (bijvoorbeeld een check die er nog niet is) helpt niemand.
document.querySelectorAll('[data-helper-tiles]').forEach((list) => {
  list.querySelectorAll('a[href^="#"]').forEach((link) => {
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    if (id && !document.getElementById(id)) link.closest('li').hidden = true;
  });
  if (!list.querySelector('li:not([hidden])')) list.hidden = true;
});
